// extracted by mini-css-extract-plugin
export default {"container":"TimeOfDayBox_container__v9PmK"};